import React from "react";
import { connect } from "react-redux";
import { GetParamsData, NamewithAsterisk } from '$Deposits/lib/LibCommonData'


class NameInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const {
            MethodsActive,
            MemberInfo,
        } = this.props;
        const { code } = MethodsActive || {}
        const { firstName } = MemberInfo || {}

        return (
            <>
                {
                    code == 'BQR' &&
                    <>
                        <p style={styles.titles}>ชื่อ-นามสกุล</p>
                        <div style={styles.firstName}>
                            {NamewithAsterisk(firstName)}
                        </div>
                    </>
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    MemberInfo: state.MemberInfo,
});
const mapDispatchToProps = {
    
};
export default connect(mapStateToProps, mapDispatchToProps)(NameInput);


const styles = {
    firstNameItem: {
        lineHeight: 45,
        color: '#999',
        fontSize: 14,
    },
    firstName: {
        backgroundColor: '#E3E3E3',
        color: "#999",
        lineHeight: "20px",
        paddingTop: 12,
        paddingRight: 16,
        paddingBottom: 12,
        paddingLeft: 16,
        borderRadius: 8,
    },
    titles: {
        color: '#666666',
        fontSize: 12,
        paddingTop: 20,
        paddingBottom: 5,
    },
}
